import { createRoot } from "react-dom/client";
import "leaflet/dist/leaflet.css";
import "./styles.css";
import { App } from "./App.js";

createRoot(document.getElementById("root")!).render(<App />);

